import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {setStore} from "trim-redux";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../../config/design/styles";
import SubTitle from "../../../../components/elements/SubTitle";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Translate} from "../../../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import {currencySymbol, price} from "../../../../../config/values";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import {Link} from "react-router-dom";
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import IconButton from "@material-ui/core/IconButton/IconButton";
class OrdersAnalyticsShort extends React.Component {
    state = {
        orders: null,
        done_orders: null,
        confirmed_orders: null,
        rejected_orders: null,
        total_payed: null,
        today_payed: null,
        total_packages: null,
        total_commission: null,
        today_commission: null,
        beginDate: '',
        endDate: '',
        loading:true,
    };
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(newProps){
        if(this.state.beginDate !== this.props.beginDate){
            await this.setState({
                beginDate: this.props.beginDate
            })
            await this.loadData();
        }
        if(this.state.endDate !== this.props.endDate){
            await this.setState({
                endDate: this.props.endDate
            })
            await this.loadData();
        }
    }
    async loadData(){
        let {beginDate,endDate} = this.state;
        if((!!beginDate && !!endDate) || (!beginDate && !endDate)){
            this.setState({
                loading:true,
            });
            let loginToken = localStorage.getItem('ACT');
            if(loginToken !== null){
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                await axios.get(`${defaultVariabls.url}/analytics/order-analytics?begin=${beginDate}&end=${endDate}`, config)
                    .then(response => {
                        console.log(response.data);
                        this.setState({
                            orders: response.data.orders,
                            done_orders:  response.data.done_orders,
                            confirmed_orders: response.data.confirmed_orders,
                            rejected_orders: response.data.rejected_orders,
                            total_payed: response.data.total_payed,
                            today_payed:response.data.today_payed,
                            total_packages: response.data.total_packages,
                            total_commission: response.data.total_commission,
                            today_commission: response.data.today_commission,
                            loading:false,
                        })
                    }).catch(error => {
                        console.log(error)
                        this.setState({
                            loading:false
                        })
                    })
            }else {
                setStore({
                    isAuth : false,
                    user : null,
                    loading:false
                });
                this.setState({
                    loading:false
                })
            }
        }
    }
    classes = this.props.classes;
    render(){
        let {orders,done_orders,confirmed_orders,rejected_orders,total_payed,today_payed,total_packages,total_commission,today_commission,loading} = this.state;
        return (
            <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} sm={6} md={3}>
                    <Grid container  style={{backgroundColor: "#fff",minHeight:130,boxShadow:"0px 5px 6px rgba(0, 0, 0, 0.04)"}} direction="row" justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={11}>
                        <SubTitle style={{display:"flex",justifyContent:"space-between",alignItems:'center'}} align="left">
                            {Translate.allOrders}
                            <Button
                                size="small"
                                color="secondary"
                                variant="contained"
                                component={Link}
                                to={'/manage/orders'}
                            >
                                {Translate.viewDetails}
                            </Button>
                            </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                        <Typography style={{textAlign:"center",marginTop:20}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : orders}</Typography>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid container  style={{backgroundColor: "#fff",minHeight:130,boxShadow:"0px 5px 6px rgba(0, 0, 0, 0.04)"}} direction="row"  justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={12}>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.doneOrders}</span>
                                <div>
                                    <strong>{done_orders}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders?status=done'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>

                            </Typography>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.confirmedOrders}</span>
                                <div>
                                    <strong>{confirmed_orders}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders?status=gathering'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.rejectedOrders}</span>
                                <div>
                                    <strong>{rejected_orders}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders?status=rejected'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid container   style={{backgroundColor: "#fff",minHeight:130,boxShadow:"0px 5px 6px rgba(0, 0, 0, 0.04)"}} direction="row"  justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={12}>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.totalSells}</span>
                                <div>
                                    <strong>{loading ? "" : price(total_payed)+" "+currencySymbol}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.todaySales}</span>
                                <div>
                                    <strong>{loading ? "" : price(today_payed)+" "+currencySymbol}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders?date=today'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.packagesSales}</span>
                                <div>
                                    <strong>{loading ? "" : price(total_packages)+" "+currencySymbol}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/packages-orders'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Grid style={{backgroundColor: "#fff",minHeight:130,boxShadow:"0px 5px 6px rgba(0, 0, 0, 0.04)"}} container   direction="row"  justify="center" className={this.classes.GridAsaPaperBaby}>
                        <Grid item xs={12}>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.totalCommissions}</span>
                                <div>
                                    <strong>{loading ? "" : price(total_commission)+" "+currencySymbol}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                            <Typography className="order_analytics_short_item">
                                <span>{Translate.todayCommission}</span>
                                <div>
                                    <strong>{loading ? "" : price(today_commission)+" "+currencySymbol}</strong>
                                    <IconButton size="small" component={Link} to={'/manage/orders?date=today'}>
                                        <VisibilityOutlinedIcon color="secondary" fontSize="small"/>
                                    </IconButton>
                                </div>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(Styles)(OrdersAnalyticsShort);